import { createLocale } from 'locales';

const localize = createLocale('freelancerAvailableJobsLocales');

export const DISTANCE_OPTIONS = [
  ['5', `< 5 ${localize('kilometer')}`],
  ['10', `< 10 ${localize('kilometer')}`],
  ['15', `< 15 ${localize('kilometer')}`],
  ['20', `< 20 ${localize('kilometer')}`],
  ['25', `< 25 ${localize('kilometer')}`],
  ['35', `< 35 ${localize('kilometer')}`],
  ['50', `< 50 ${localize('kilometer')}`],
  ['', localize('allDistances')],
];

export const TYPE_OPTIONS = [
  ['any', localize('allAssignments')],
  ['personal', localize('personalAssignments')],
  ['urgent', localize('urgentAssignments')],
  ['choice', localize('interestAssignments')],
];

export const BUTTON_ACTION = {
  accept: 'ACCEPT',
  refuse: 'REFUSE',
};

export const CONFIRM_MESSAGES = {
  accept: localize('confirmAccept'),
  refuse: localize('confirmRefuse'),
};

Object.freeze(BUTTON_ACTION);
Object.freeze(TYPE_OPTIONS);
